import React, {
  useState,
  useMemo,
  useCallback,
  useRef,
  useEffect,
} from "react";
import dayjs from "dayjs";
import "./styles.css";
import Clashfinder from ".";
import { TypedDocumentNode, useLazyQuery, useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { GET_EDITION } from "../editionsBands/graphql";
import {
  FestivalEditionQuery,
  Exact,
  Scalars,
} from "../../__generated__/graphql";
import { LoadingOverlay } from "../../components/Loading";

export const ClashfinderContainer: React.FC = () => {
  const [getEdition, { data, loading, error }] = useLazyQuery(GET_EDITION);
  //  as TypedDocumentNode<
  //     FestivalEditionQuery,
  //     Exact<{
  //       id: Scalars["String"]["input"];
  //     }>
  //   >
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;
    getEdition({
      variables: {
        id: id!,
      },
    });
  }, [id]);

  if (!data?.festivalEdition || loading) {
    return <LoadingOverlay loading />;
  }

  const announcementBands = data?.festivalEdition?.announcements.flatMap(
    (item) => item.bands
  );

  const allBands = [
    ...data?.festivalEdition?.bands,
    ...announcementBands.filter((band) => !!band.stage && !!band.date),
  ];

  // @ts-ignore
  return <Clashfinder bandBookings={allBands} />;
};
